import { h } from "preact";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	title: {
		flexGrow: 1,
	},
}));

export default function Picto2() {
	const classes = useStyles();

	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48.87 29.54" width="47px">
			<g id="Calque_2" data-name="Calque 2">
				<g id="design">
					<path d="M24.43,0C13.74,0,4.46,5.78.13,14.24a1.14,1.14,0,0,0,0,1c4.33,8.46,13.6,14.25,24.3,14.25s20-5.79,24.31-14.25a1.14,1.14,0,0,0,0-1C44.41,5.78,35.13,0,24.43,0Zm0,2.27a24.89,24.89,0,0,1,22,12.5,24.89,24.89,0,0,1-22,12.5,24.89,24.89,0,0,1-22-12.5A24.89,24.89,0,0,1,24.43,2.27Zm0,2.28A10.23,10.23,0,1,0,34.66,14.77,10.24,10.24,0,0,0,24.43,4.55Zm0,2.27a8,8,0,1,1-7.95,8A7.94,7.94,0,0,1,24.43,6.82Z" />
				</g>
			</g>
		</svg>
	);
}
